import url from 'libraries/front-end-core/core/url'
import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { CURRENT_AWARENESS_REVIEW } from 'constants/controllers'

export default new Controller({
  name: 'LegacyNewsReviewRedirect',
  route: ':aol/legreview/:selectedIds',
  controller (Router, { params, query }) {
    const target = url(CURRENT_AWARENESS_REVIEW, params, query)
    replaceUrl(target)
  }
})
